module.exports = __webpack_public_path__ + "assets/images/pages/listarobinson/listarobinson-1.png?02e81d8f";